export default __webpack_public_path__ + "static/media/aboutus2.0049a37e.jpg";